import { IconComponent } from 'models/icons';

/**
 * This file was auto-generated using svgr
 *
 * Source file: assets/icons/redo.svg
 */
const IconRedo: IconComponent = ({
  size = 24,
  color = 'white',
  className,
  svgElementProps: props = {},
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    color={color}
    className={className}
    {...props}
  >
    <path
      d="M17.18 12a.55.55 0 00-.021-.155c0-.027 0-.056-.012-.082-.013-.026-.04-.042-.058-.066-.017-.025-.017-.057-.037-.08l-4.148-4.725a.587.587 0 00-.856-.086.588.588 0 00-.031.86l3.287 3.744H6.478a.59.59 0 000 1.18h8.826l-3.287 3.745a.588.588 0 00.24.977.592.592 0 00.466-.046.587.587 0 00.18-.156l4.15-4.724c.02-.023.02-.055.036-.08.016-.027.045-.04.058-.067.012-.028 0-.055.012-.083A.55.55 0 0017.18 12z"
      fill="currentColor"
    />
    <path
      d="M12 24a12 12 0 1112-11.998A12.035 12.035 0 0112 24zm0-22.515a10.516 10.516 0 1010.515 10.517A10.545 10.545 0 0012 1.485z"
      fill="currentColor"
    />
  </svg>
);

export default IconRedo;
